const arrayFromNumber = (number) => {
  return [...Array(number).keys()]
}

export default arrayFromNumber
